export const SET_STAMPS_CONFIG = 'SET_STAMPS_CONFIG'